(function () {
  'use strict';

  function openModal(id) {
    const modal = document.getElementById('cms-modal-' + id);
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const closeBtn = modal.querySelector('.cms-modal-close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(id) {
    const modal = document.getElementById('cms-modal-' + id);
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function closeAllModals() {
    document.querySelectorAll('.cms-modal-overlay.is-open').forEach(function (modal) {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
    });
    document.body.style.overflow = '';
  }

  function hideCmsPopupTarget(btn) {
    const selector = btn.getAttribute('data-cms-hide-selector');
    if (!selector) return;
    const el = btn.closest(selector);
    if (!el) return;
    el.style.display = 'none';
  }

  document.addEventListener('click', function (e) {
    const cmsCloseBtn = e.target.closest('.cms-popup__close[data-cms-hide-selector]');
    if (cmsCloseBtn) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      hideCmsPopupTarget(cmsCloseBtn);
      return;
    }

    const trigger = e.target.closest('[data-modal-trigger]');
    if (trigger) {
      openModal(trigger.dataset.modalTrigger);
      return;
    }

    const closeBtn = e.target.closest('[data-modal-close]');
    if (closeBtn) {
      closeModal(closeBtn.dataset.modalClose);
      return;
    }

    if (e.target.classList.contains('cms-modal-overlay')) {
      closeAllModals();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllModals();
  });
})();
